import { defaultConfig, getApi, getContentRoutes, getFooterLinks, getHeaderLinks } from '../../base/defaultConfig';

export const config = {
  ...defaultConfig,
  'global.brandName': 'Breakfree Holidays',
  'google.gtm': 'GTM-K92HRPS',
  'socialMedia.telephone': 'tel:03332201901',
  'user.optin.emailOpt': true,
  'user.optin.smsOpt': false,
  'user.optin.thirdOpt': true,
  'logo.width': '258px',
  siteCode: 'SN',
  'campaign.referer': 'suntravel',
};

export const contentRoutes = [
  ...getContentRoutes(config),
  { path: '/privacy-policy', url: 'age/3' },
  { path: '/customer-charter', url: 'age/84' },
  { path: '/offers', url: 'age/1824' },
  { path: '/about-us', url: 'age/1512' },
  { path: '/european-holiday-parks', url: 'age/1572' },
  { path: '/hotels', url: 'age/1828' },
  { path: '/cheap-caravan-holidays-uk-europe', url: 'age/225' },
];

const footerData = getFooterLinks(config);
footerData.findAHoliday1.links[5].path = '/european-holiday-parks';
export const footerLinks = footerData;

export const urls = getApi(config, 'api');

export const HeaderLinks = getHeaderLinks([1, 2, 3, 4, 5, 7]);
